import { c as _c } from "react/compiler-runtime";
import { ListItemButton, ListItemIcon } from '@mui/material';
import { StyledListItemLogoContainer } from './styles';
import { type NavHeaderProps } from './types';
import Logo from '../Logo';
const NavHeader = t0 => {
  const $ = _c(7);
  const {
    Link,
    CustomLogo
  } = t0;
  let t1;
  if ($[0] !== CustomLogo) {
    t1 = CustomLogo ?? <Logo size="large" />;
    $[0] = CustomLogo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <StyledListItemLogoContainer><ListItemButton><ListItemIcon>{t1}</ListItemIcon></ListItemButton></StyledListItemLogoContainer>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== Link || $[5] !== t2) {
    t3 = <Link>{t2}</Link>;
    $[4] = Link;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default NavHeader;